<h2 class="form-h2">Add User</h2>
<form [formGroup]="form" autocomplete="off" style="margin-top: 8px">
  <div class="form-fields">
    <!-- First Name Field -->
    <mat-form-field appearance="outline">
      <mat-label>First Name</mat-label>
      <input matInput type="text" formControlName="firstName" placeholder="John" required data-lpignore="true" autocomplete="off" />
      @if (firstName.hasError("required")) {
        <mat-error> First Name Required </mat-error>
      }
    </mat-form-field>

    <!-- Last Name Field -->
    <mat-form-field appearance="outline">
      <mat-label>Last Name</mat-label>
      <input matInput type="text" formControlName="lastName" placeholder="Ex. Doe" required data-lpignore="true" autocomplete="off" />
      @if (lastName.hasError("required")) {
        <mat-error> Last Name Required </mat-error>
      }
    </mat-form-field>

    <!-- E-Mail Field -->
    <mat-form-field appearance="outline">
      <mat-label>E-Mail</mat-label>
      <input matInput type="email" formControlName="email" placeholder="Ex. pat@example.com" required data-lpignore="true" autocomplete="off" />
      @if (email.hasError("email")) {
        <mat-error> E-mail Invalid </mat-error>
      } @else if (email.hasError("required")) {
        <mat-error> E-Mail Required </mat-error>
      }
    </mat-form-field>
  </div>
</form>

@if (apiErrorMessage()) {
  <div class="alert-danger" style="margin-top: 24px">
    Edit User Error
    {{ apiErrorMessage() }}
  </div>
}

<div class="form-action-btn">
  <button mat-raised-button (click)="routeBack()">Cancel</button>
  <button mat-flat-button cdkFocusInitial [disabled]="form.invalid || saveState()" (click)="onSubmit()">Add</button>
</div>
